<template>
  <div id="app">
    <!-- <transition :name="transitionName"> -->
    <router-view v-if="isRouterAlive" />
    <!-- </transition> -->
    <!-- <keep-alive include="new_guide">
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath" />
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive" /> -->
  </div>
</template>


<style lang="scss">
@import url(assets/css/reset.css);
@import url(assets/css/layout.css);
@import url(assets/css/animate.css);

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--fontColor);
}

// .fade-enter-active, .fade-leave-active {
//   transition: 0.5s;
// }
// .fade-enter{
//   // transform: translateX(500px)
// }
//  .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
//   transform: translateX(-500px)
// }
</style>

<script>
export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      transitionName: null,
      isRouterAlive: true,
    };
  },
  methods: {
    reload() {
      console.log('reload occure')
      this.isRouterAlive = false;
      this.$nextTick(() => { this.isRouterAlive = true });
    },
  }
};
</script>
